
import {
    ApiEventSlug, CounterSlug,
    DataDrivenSlug, DbstoreSlug, EmailSlug, EventSlug,
    LookupSlug,
    RobinsonSlug,
    SegmentSlug, SftpSlug,
    SingleShootSlug,
    SmsSlug, WebserviceSlug, WhatsappSlug
} from "../../config/Config";
import DataDriven from "../workflow/components/DataDriven/DataDriven";
import SingleShoot from "../workflow/components/SingleShoot/SingleShoot";
import Segment from "../workflow/components/Segment/Segment";
import Sms from "../workflow/components/Sms/Sms";
import Lookup from "../workflow/components/Lookup/Lookup";
import Robinson from "../workflow/components/Robinson/Robinson";
import Email from "../workflow/components/Email/Email";
import Whatsapp from "../workflow/components/Whatsapp/Whatsapp";
import Counter from "../workflow/components/Counter/Counter";
import Event from "../workflow/components/Event/Event";
import Sftp from "../workflow/components/Sftp/Sftp";
import Webservice from "../workflow/components/Webservice/Webservice";
import ApiEvent from "../workflow/components/ApiEvent/ApiEvent";

const Settings = (props) => {
    const {journey, currentNode, previousNode} = props

    const CommonOptions = {
        journey: journey,
        currentNode: currentNode,
        previousNode: previousNode,
    }

    const getForm = () => {
        let Output
        switch (currentNode.data.slug){
            case DataDrivenSlug:
                Output = <DataDriven {...CommonOptions} />
                break;

            case SingleShootSlug:
                Output = <SingleShoot {...CommonOptions} />
                break;

            case ApiEventSlug:
                Output = <ApiEvent {...CommonOptions} />
                break;

            case SegmentSlug:
                Output = <Segment {...CommonOptions} />
                break;

            case LookupSlug:
                Output = <Lookup {...CommonOptions} />
                break;

            case RobinsonSlug:
                Output = <Robinson {...CommonOptions} />
                break;

            case SmsSlug:
                Output = <Sms {...CommonOptions} />
                break;

            case EmailSlug:
                Output = <Email {...CommonOptions} />
                break;

            case WhatsappSlug:
                Output = <Whatsapp {...CommonOptions} />
                break;

            case CounterSlug:
                Output = <Counter {...CommonOptions} />
                break;

            case EventSlug:
                Output = <Event {...CommonOptions} />
                break;

            case SftpSlug:
                Output = <Sftp {...CommonOptions} />
                break;

            case WebserviceSlug:
                Output = <Webservice {...CommonOptions} />
                break;
        }

        return Output
    }


    const Component = getForm()



    return (
        <div className="Form">
            {Component}
        </div>
    )
}

export default Settings;